import type { ComponentProps } from 'react';
import { VariationDisplay } from '@gonfalon/flag-variations/VariationDisplay';
import clsx from 'clsx';

import styles from './ProgressiveRolloutVariationDisplay.module.css';

export function ProgressiveRolloutVariationDisplay({ className, ...props }: ComponentProps<typeof VariationDisplay>) {
  return <VariationDisplay {...props} className={clsx(styles.variationDisplay, className)} />;
}
